const e = {
  name: "ExternalLink",
  dimensions: { width: 14, height: 14 },
  content: `
   <path fill-rule="evenodd" clip-rule="evenodd" d="M3 1C3 0.447715 3.44772 0 4 0H12.9998C12.9999 0 12.9998 0 12.9998 0C13.1354 0 13.2649 0.0269856 13.3828 0.0758788C13.4999 0.124319 13.6096 0.195951 13.705 0.290776C13.7064 0.292185 13.7078 0.293599 13.7092 0.295017C13.9023 0.489245 13.9992 0.743006 14 0.997001C14 0.998 14 0.999 14 1V10C14 10.5523 13.5523 11 13 11C12.4477 11 12 10.5523 12 10V3.41421L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L10.5858 2H4C3.44772 2 3 1.55228 3 1Z" fill="currentColor"/>`
};
export {
  e as ExternalLink
};
